export default "__VITE_ASSET__BJ2ievlI__"